import { render } from "./WorkloadRecommendingDialog.vue?vue&type=template&id=29075474&scoped=true"
import script from "./WorkloadRecommendingDialog.vue?vue&type=script&lang=js"
export * from "./WorkloadRecommendingDialog.vue?vue&type=script&lang=js"

import "./WorkloadRecommendingDialog.vue?vue&type=style&index=0&id=29075474&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29075474"]])

export default __exports__